import { render } from "./SalesAreaDetail.vue?vue&type=template&id=5acd4d35"
import script from "./SalesAreaDetail.vue?vue&type=script&lang=js"
export * from "./SalesAreaDetail.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src834291806/src/oms-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__